export default __webpack_public_path__ + "static/media/playroompage-cross.1af4e10b.svg";